import { createSectionName } from 'components/Dashboard/helpers/controlActiveFilters';
import { useState } from 'react';
import LocalStorage from 'utils/LocalStorage';

const useTranscriptDetection = () => {
  const [showTranscriptsBanner, setShowTranscriptsBanner] = useState(true);
  const sectionName = createSectionName();
  const isTranscriptionSectionVisited =
    !!LocalStorage.getItem(`transcriptionSectionVisited`) &&
    LocalStorage.getItem(`transcriptionSectionVisited`) === 'true';

  const conditionToShowTranscriptsBanner =
    (sectionName === 'ParliamentaryRecord' || sectionName === 'UpcomingEvents') &&
    !isTranscriptionSectionVisited &&
    showTranscriptsBanner;

  const markTranscriptionSectionAsVisited = () => {
    setShowTranscriptsBanner(false);
    LocalStorage.setItem(`transcriptionSectionVisited`, 'true');
  };

  return { conditionToShowTranscriptsBanner, markTranscriptionSectionAsVisited };
};

export default useTranscriptDetection;
